import swiperSlider from "./swiper/swiperSlider"

export default function brandsSlider() {
    const sliders = document.querySelectorAll('[data-brands-slider]')
    sliders.forEach(slider => new swiperSlider(slider));
}